<template>
  <gmap-map :center="center" :zoom=3 style="width: 100%; height: 500px">
    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
      {{infoContent}}
    </gmap-info-window>
    <gmap-marker :key="i" v-for="(m,i) in markers" :position="m.position" :clickable="true" @click="toggleInfoWindow(m,i)"></gmap-marker>
  </gmap-map>
</template>

<script>
    export default {
        name: "GetBoardedOfficeLocation",
      data() {
        return {
          center: { lat: 31.379158, lng: 31.106587 },
          infoContent: '',
          infoWindowPos: null,
          infoWinOpen: false,
          currentMidx: null,
          //optional: offset infowindow so it visually sits nicely on top of our marker
          infoOptions: {
            pixelOffset: { width: 0, height: -35 }
          },
          markers: [
            { position: { lat: 28.659769, lng: 77.369307 }, infoText: 'GetBoarded Technologies, SG Estates - SG Alpha Tower' },
            { position: { lat: 40.619379, lng:  -8.666664 }, infoText: 'GetBoarded Technologies PCI - Creative Science Park' },
          ]
        }
      },
      methods: {
        toggleInfoWindow: function(marker, idx) {
          this.infoWindowPos = marker.position;
          this.infoContent = marker.infoText;
          //check if its the same marker that was selected if yes toggle
          if (this.currentMidx === idx) {
            this.infoWinOpen = !this.infoWinOpen;
          }
          //if different marker set infowindow to open and reset current marker index
          else {
            this.infoWinOpen = true;
            this.currentMidx = idx;
          }
        }
      }
    }
</script>

<style scoped>

</style>
